var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.833a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1h-5Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.833a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1h-5Z",
    fill: "#747F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.667a.5.5 0 0 1 .5-.5h5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: "#818C96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.667a.5.5 0 0 1 .5-.5h5a.5.5 0 1 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: "#747F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.666 5.369-1.772.91a.5.5 0 0 1-.456-.89l7.23-3.71a2.5 2.5 0 0 1 2.236-.023l7.648 3.728a.5.5 0 0 1-.438.899l-1.781-.868v10.252a1.5 1.5 0 0 1-1.5 1.5H5.166a1.5 1.5 0 0 1-1.5-1.5V5.369Zm5.458-2.8a1.5 1.5 0 0 1 1.342-.014l4.872 2.374a.512.512 0 0 0-.005.071v10.667a.5.5 0 0 1-.5.5H5.166a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-.018-.135l4.476-2.297Z",
    fill: "#818C96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.666 5.369-1.772.91a.5.5 0 0 1-.456-.89l7.23-3.71a2.5 2.5 0 0 1 2.236-.023l7.648 3.728a.5.5 0 0 1-.438.899l-1.781-.868v10.252a1.5 1.5 0 0 1-1.5 1.5H5.166a1.5 1.5 0 0 1-1.5-1.5V5.369Zm5.458-2.8a1.5 1.5 0 0 1 1.342-.014l4.872 2.374a.512.512 0 0 0-.005.071v10.667a.5.5 0 0 1-.5.5H5.166a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-.018-.135l4.476-2.297Z",
    fill: "#747F88"
  })));
};

export default SvgHome;